import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import seoMap from './seoMap';

// Composant SEOUpdater - met à jour title et description à chaque navigation
const SEOUpdater = () => {
  const location = useLocation();

  useEffect(() => {
    // Normaliser le pathname (supprimer trailing slash sauf pour "/")
    let pathname = location.pathname;
    if (pathname !== '/' && pathname.endsWith('/')) {
      pathname = pathname.slice(0, -1);
    }

    // Chercher dans le mapping SEO
    const seo = seoMap[pathname];

    if (seo) {
      // Mettre à jour le title
      document.title = seo.title;

      // Mettre à jour la meta description
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', seo.description);
      }
    } else {
      // Fallback vers la home si route non trouvée dans le mapping
      const fallback = seoMap['/'];
      document.title = fallback.title;
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', fallback.description);
      }
    }
  }, [location.pathname]);

  return null; // Ce composant ne rend rien
};

export default SEOUpdater;
